var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('img',{staticStyle:{"justify-content":"center"},attrs:{"src":require("../../assets/img/404.png"),"alt":"Description"}})])
}]

export { render, staticRenderFns }